export default __webpack_public_path__ + "static/media/your_challenge.0d579efe.png";